'use strict';

function ColorpickerController ($scope, sbColorpicker) {

  this.colors = this.colors || sbColorpicker.getColors();
  this.defaultColor = this.defaultColor || this.colors[0];
  this.activeColor = this.activeColor || this.defaultColor;

  /**
   * Triggered when the user click on a color box
   *
   * @param  {string} color the color selected by the user
   */
  this.select = function (color) {
    this.activeColor = color;
    $scope.$emit('colorpicker:selected', color);
  };


  // ## Event Handlers

  this._reset = function () {
    this.activeColor = this.defaultColor;
  };

  this._set = function (e, color) {
    this.select(color);
  };

  $scope.$on('colorpicker:reset', this._reset.bind(this));
  $scope.$on('colorpicker:set', this._set.bind(this));
}

module.exports = ColorpickerController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/colorpicker/src/ColorpickerController.js